/**
 * Message for a failed import request. When the server answered, its own message says what is
 * wrong with the file; "Lỗi kết nối" is kept for when no response came back at all.
 */
export function getImportErrorMessage(error: any): string {
  const message = error?.response?.data?.message;
  if (typeof message === 'string' && message.trim()) {
    return message;
  }

  if (error?.response) {
    return `Máy chủ gặp lỗi (${error.response.status}), vui lòng thử lại sau.`;
  }

  return 'Lỗi kết nối: ' + (error?.message || 'Không thể kết nối đến server');
}
